import "./App.css";
import AppRoutes from "./routes";
import { Toaster } from "react-hot-toast";

function App() {
  const isMobile = window.innerWidth <= 640;

  return (
    <>
         <Toaster
        position={isMobile ? "top-center" : "top-right"}
        toastOptions={{
          duration: 8000,
          style: {
            background: "#111827",
            color: "#fff",
            marginTop: isMobile ? "80px" : "120px",
          },
        }}
      />
      <AppRoutes />
    </>
  );
}

export default App;
